import React from 'react';
import { useEffect, useState } from "react";
import { SquareArrowDown, SquareArrowUp } from "lucide-react";
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Help.css";

export default function Help() {
  const [FAcontent, setFAContent] = useState(null);
  const [showAns, setShowAns] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();

  useEffect(() => {
    fetch("/data/Help.json")
      .then((res) => res.json())
      .then((data) => setFAContent(data.FA))
      .catch((err) => setConsoleError("Error loading content:", err))
  }, []);

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])

  if (!FAcontent) return <Loading />;  

  return (
    <>
      <NavbarLog />
      <div className="help-page">
        <div className="help-grid">
          <h1>{FAcontent.h1}</h1>
          <p>{FAcontent.p1}</p>

          {FAcontent.questions.map((sec, idx) => (
            <div className="help-section" key={idx}>
              <span style={{display:"flex", gap: '10px', cursor:'pointer'}} onClick={()=>setShowAns(showAns===idx? null:idx)}>{showAns===idx?<SquareArrowUp/>:<SquareArrowDown/>}<h2>{sec.Q}</h2></span>
              {showAns===idx &&
                <p>{sec.A}</p>
              }
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}